module.exports = __webpack_public_path__ + "img/Weapon_275.f52c39bc.png";